export default "__VITE_ASSET__WG$HDsqx__"